export const Work = [
    {
        id:1,
        name:"Gym-Website",
        description: "Developed the gym websites using simple html, css",
        tags:["html","css"],

        demo:"https://im-kamil.github.io/Project-1-HTML--CSS--WEBSITE-/",
        github:"https://github.com/im-kamil/Project-1-HTML--CSS--WEBSITE-"
    },
    {
        id:2,
        name:"Food Delivery Website",
        description: "Implemented a real-time Food Delivery Websites using Frontend",
        tags:["html","css","javascript"],

        demo:"https://im-kamil.github.io/Awesome-food-delivery-website-in-HTML-CSS/",
        github:"https://github.com/im-kamil/Awesome-food-delivery-website-in-HTML-CSS "
    },
    {
        id:3,
        name:"Jumping Dead Game",
        description: " Osm GAME Design as Canvas for proper level wise running game",
        tags:["html","css","javascript", "canvas"],

        demo:"https://im-kamil.github.io/jumping-dead-game-in-javascript/JumpingDeadGame_JavaScript/JumpingDeadPlatform_Game/index.html",
        github:"https://github.com/im-kamil/jumping-dead-game-in-javascript/tree/main/JumpingDeadGame_JavaScript/JumpingDeadPlatform_Game"
    },
    {
        id:4,
        name:"ToDoList App",
        description: "A todolist app for routines of daily life using react",
        tags:["html","css","javascript" , "react"],

        demo:"https://kamill.netlify.app/",
        github:"https://github.com/im-kamil/To-do-List-app-in-react/tree/main/todolist"
    },
    {
        id: 5,
        name: 'Stresser',
        description: `Stresser stresses on reducing peoples's stress and anxiety by providing therapy, diet, diary and chat features`,
        tags: ['react','javascript','node.js','express','mongodb','mongoose'],
        demo: 'stresser-on.herokuapp.com/',
        github: 'https://github.com/im-kamil/Stresser'
    }
] 